<template>
  <div class="promotionPage page">
    <div class="container">
      <search-template
        :promotion-group-id="promotion.id"
        :search-title="promotion.name"
        :promotion-header-content="{
          image: promotion.imageUrl,
          description: promotion.description,
        }"
        list-name="Promotion list"
        current-breadcrumb="Promocje"
        route-name="promotions-slug"
        route-pagination-name="promotions-page-number"
        :show-heading="false"
      />
    </div>

    <LazyHydrate :when-visible="{ rootMargin: '100px' }">
      <newsletter-home white />
    </LazyHydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import { mapState, mapMutations } from 'vuex';
import SearchTemplate from '~/components/SearchTemplate';

export default {
  name: 'PromotionPage',
  components: {
    LazyHydrate,
    SearchTemplate,
    NewsletterHome: () => import('~/components/Newsletter/NewsletterHome'),
  },
  nuxtI18n: {
    paths: {
      pl: '/promocje/:slug/strona/:number',
      en: '/promotions/:slug/page/:number',
    },
  },
  async asyncData({ app, $config, error, $axios, route, redirect }) {
    try {
      const {
        data: { promotion, seo },
      } = await $axios.get(`${$config.baseOfixApi}/e-commerce/v1/promotions/${route.params.slug}`, {
        useCache: true,
      });

      if (promotion.slug !== route.params.slug) {
        redirect(
          301,
          app.localePath({
            name: 'promotions-page-number',
            params: { slug: promotion.slug, number: route.params.number },
          }),
        );
      }

      return {
        promotion,
        seo,
      };
    } catch (e) {
      error({
        statusCode: 404,
        message: e.response.data.message ? e.response.data.message : 'Promotion not found',
      });
    }
  },
  computed: {
    ...mapState({
      pagination: state => state.productsFilters.search.pagination,
    }),
  },
  destroyed() {
    this.setPromotionGroupId({ type: 'search', value: null });
  },
  methods: {
    ...mapMutations({
      setPromotionGroupId: 'productsFilters/setPromotionGroupId',
    }),
  },
  head() {
    const currentPage = this.$helper.countCurrentPage(
      this.pagination.limit,
      this.pagination.offset,
    );

    return {
      title: `Strona ${currentPage} - ${this.promotion.name} - ofix.pl`,
      meta: [
        ...[
          {
            hid: 'description',
            name: 'description',
            content: `Strona ${currentPage} - ${this.promotion.name} - Szeroka oferta produktów w niskich cenach. Darmowa dostawa od 100PLN w 24h.`,
          },
        ],
        ...[
          {
            name: 'robots',
            content: 'noindex, follow',
          },
        ],
      ],
      script: [...this.$helper.schemaData(this.seo.schemaOrgData)],
      link: this.$helper.prevNextUrl(
        this.$route.query,
        this.pagination.offset,
        this.pagination.limit,
        this.pagination.countTotal,
        'promotions-slug',
        'promotions-page-number',
      ),
    };
  },
};
</script>
